var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Confirm',{ref:"confirmAction"})
}
var staticRenderFns = []

export { render, staticRenderFns }